import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useQuote = (propertyId, { checkIn, checkOut, guests }, refreshKey = 0) => {
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setQuote(null);
    setError("");
    if (!propertyId || !checkIn || !checkOut) return;
    let active = true;
    setLoading(true);
    api
      .get(`/properties/${propertyId}/quote`, { params: { check_in: checkIn, check_out: checkOut, guests } })
      .then(({ data }) => active && setQuote(data))
      .catch((e) => active && setError(e?.response?.data?.detail || "Não foi possível verificar as datas."))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [propertyId, checkIn, checkOut, guests, refreshKey]);

  return { quote, error, loading };
};

export const formatDate = (iso) =>
  iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("pt-PT", { day: "numeric", month: "short", year: "numeric" }) : "";

export const euro = (n) => `${Number(n).toLocaleString("pt-PT")} €`;
